<template>
  <div class="w100 flex-box management-view">
    <div class="bg-w pt20 card-shadow of-y management-nav-bar">
      <!-- <router-link class="flex-box al-c cu-p side-bar-item" v-for="(item, index) in routerList" :key="index" :to="item.path">
        <i :class="item.icon"></i>
        <span class="ml10 flex-1 ellipsis">{{ item.label }}</span>
      </router-link> -->
      <!-- <el-menu :default-active="$route.path"> -->
      <el-menu :default-active="defaultActive" :unique-opened="true">
        <el-submenu
          :index="String(index)"
          v-for="(item, index) in routerList"
          :key="index"
        >
          <template slot="title">
            <i :class="item.icon"></i>
            <span>{{ item.label }}</span>
          </template>
          <template v-for="(e, i) in item.children">
            <el-menu-item
              :index="e.path"
              :key="i"
              v-if="hasItem(e.path)"
              @click="menuClick(e)"
            >
              {{ e.label }}
            </el-menu-item>
          </template>
        </el-submenu>
      </el-menu>
    </div>
    <div class="flex-1 ml20 mt20 mb20 mr20 card-shadow bg-w of-y flex-box">
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {fetchMenuTree} from '@/api/admin/menu';

export default {
  name: "Management",
  components: {},
  props: [],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      routerList: [],
      defaultActive:"",
    };
  },
  computed: {
    ...mapGetters(["userData"]),
  },
  created() {
    this.fetchMenuTree();
  },
  mounted() {
  },
  destroyed() {},
  methods: {
    addViewRouter() {
        // console.log(this.userData.routerData,'this.userData.routerData');
        this.routerList = this.routerList.filter(
        val => this.userData.routerData.indexOf(val.path) > -1
      );
    this.defaultActive = this.routerList[0].children[0].path
    this.$router.push(this.defaultActive)
    },
    fetchMenuTree(){
      fetchMenuTree()
      .then(({data}) => {
          const managementMenu = data.data.find(item => item.id == 1028).children;
        this.routerList = managementMenu

        this.addViewRouter();
      })
    },
    hasItem(path){
      return this.userData.routerData.includes(path)
    },
    isAdmin(){
      return (this.userData.roleCodes||[]).includes('ROLE_ADMIN')
    },
    menuClick(val){
      this.$router.push(val.path)
    },
  },
  watch: {},
  filters: {},
};
</script>

<style scoped lang="less">
.management-view {
  height: calc(100vh - 70px);
}

</style>
